import React, { useState } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import { replacePlaceholder } from "../../../Utils/Utils";

function OpenTextQuestion({ question, handleChange, formValues, showError }) {
  const hasAnswer = formValues[question.tempId];
  const [isAnswerValidOT, setIsAnswerValidOT] = useState(true);

  const handleEditorChange = (event) => {
    const value = event.target.value;
    if (value.length > 1024) {
      setIsAnswerValidOT(false);
      return;
    }
    setIsAnswerValidOT(true);
    handleChange(event); // This updates formValues directly
  };

  const questionText = replacePlaceholder(question.questionText, formValues);

  return (
    <Card className={`mt-3 ${question.isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form.Group>
          <div className="d-flex flex-column">

            <Form.Label>
              <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                {question.tempId}.{questionText}
                {question.isMandatory && <span className="text-danger">*</span>}
              </b>
            </Form.Label>
            <Form.Label>
              <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
            </Form.Label>
            {question.isMandatory && showError && !hasAnswer && (
              <ErrorComponent message={question.requiredErrorText} />

            )}

            {!isAnswerValidOT && (
              <ErrorComponent message="Answer should contain max 1024 characters" />
            )}
          </div>
          <Form.Control
            as="textarea"
            rows={3}
            value={formValues[question.tempId] || ""} // Use formValues directly
            name={question.tempId}
            onChange={handleEditorChange}
            required={question.isMandatory}
            placeholder={question.placeHolderText}
          />


        </Form.Group>
      </Card.Body>
    </Card>
  );
}


export default OpenTextQuestion;
